import React, {useEffect, useState} from 'react';
import {InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import {useSelector} from "react-redux";
import {selectInstrumentsSorted} from "../../store/selectors";
import {Instrument, InstrumentShortVersion} from "../../gen/api";

type Props = {
  previousInstruments: InstrumentShortVersion[]
  setPreviousInstruments: React.Dispatch<React.SetStateAction<InstrumentShortVersion[]>>
}

function AddPreviousVersionsDropDown({previousInstruments, setPreviousInstruments}: Props) {
  const [instrumentDropdownList, setInstrumentDropdownList] = useState<Instrument[]>([]);
  const instruments = useSelector(selectInstrumentsSorted);

  useEffect(() => {
    setInstrumentDropdownList([...instruments.filter(instrument => !previousInstruments.find(prevInstrument => prevInstrument.id === instrument.id))]);
  }, [previousInstruments, instruments]);

  const handleChange = (event: SelectChangeEvent) => {
    const selectedInstrumentId = event.target.value as string;
    if (selectedInstrumentId) {
      const instrumentName = instruments?.find(instrument => instrument.id === selectedInstrumentId)?.name;
      if (!instrumentName) return;
      setPreviousInstruments([...previousInstruments, {
        id: selectedInstrumentId,
        name: instrumentName
      }]);
    }
  };

  return (
      <>
        <FormControl fullWidth disabled={instrumentDropdownList?.length === 0}>
          <InputLabel id="previous-instrument-label">Version hinzufügen</InputLabel>
          <Select
              labelId="previous-instrument-label"
              id="previous-instrument"
              value={""}
              label="Version hinzufügen"
              onChange={handleChange}
          >
            {instrumentDropdownList.map(instrument =>
                <MenuItem key={instrument.id} value={instrument.id}>{instrument.name}</MenuItem>)
            }
          </Select>
        </FormControl>
      </>
  );
}

export default AddPreviousVersionsDropDown;
